import { render, staticRenderFns } from "./ModalInfoMarkdown.vue?vue&type=template&id=6cbe4fc0&scoped=true"
import script from "./ModalInfoMarkdown.vue?vue&type=script&lang=js"
export * from "./ModalInfoMarkdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbe4fc0",
  null
  
)

export default component.exports